if (!window.__bmPasswordToggleBound) {
  window.__bmPasswordToggleBound = true;

  document.addEventListener('click', function (event) {
    var toggleButton = event.target.closest('.password-toggle');
    if (!toggleButton) return;

    var input = document.getElementById(toggleButton.getAttribute('aria-controls'));
    if (!input) return;

    var isPasswordVisible = input.getAttribute('type') === 'text';

    input.setAttribute('type', isPasswordVisible ? 'password' : 'text');
    toggleButton.setAttribute('aria-pressed', String(!isPasswordVisible));
    toggleButton.setAttribute(
      'aria-label',
      isPasswordVisible ? toggleButton.dataset.showPasswordText : toggleButton.dataset.hidePasswordText
    );
  });
}
